// extracted by mini-css-extract-plugin
export default {"content":"agentinfo_content__O+mgY"};